import {FC, useState} from "react";
import {UsersTable} from "../UsersTable/UsersTable.tsx";
import {Button, Flex, Input} from "antd";
import {PlusOutlined, SearchOutlined} from "@ant-design/icons";
import styles from './UsersTab.module.css';
import {useUsers} from "../../../../queries/useUsers.ts";
import {AddUserModal} from "../AddUserModal/AddUserModal.tsx";
import {isFirManager, isRegionManager} from "../../../../utils/userTypeGuards.ts";

export const UsersTab: FC = () => {
    const { data: users, isLoading, refetch } = useUsers();
    const [filterValue, setFilterValue] = useState('');

    const filteredUsers = users?.filter((user) =>
        user.id.toString().includes(filterValue) ||
        user.first_name.toLowerCase().includes(filterValue.toLowerCase()) ||
        user.last_name.toLowerCase().includes(filterValue.toLowerCase()) ||
        isFirManager(user) && user.firs.some(({ id, name, region }) =>
            id.toLowerCase().includes(filterValue.toLowerCase()) ||
            name.toLowerCase().includes(filterValue.toLowerCase()) ||
            region.name.toLowerCase().includes(filterValue.toLowerCase())
        ) ||
        isRegionManager(user) && user.region?.name.toLowerCase().includes(filterValue.toLowerCase())
    ) || [];

    const [addModalOpen, setAddModalOpen] = useState(false);

    return (
        <Flex vertical gap={16} style={{ width: '100%' }}>
            <Flex justify="space-between">
                <Input
                    className={styles.searchInput}
                    prefix={<SearchOutlined />}
                    placeholder="Поиск"
                    value={filterValue}
                    onChange={(v) => setFilterValue(v.target.value)}
                />
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => setAddModalOpen(true)}
                >Добавить</Button>
            </Flex>
            <UsersTable
                users={filteredUsers}
                loading={isLoading}
                onUpdate={refetch}
            />
            <AddUserModal
                open={addModalOpen}
                onClose={() => setAddModalOpen(false)}
            />
        </Flex>
    )
}